<template>
  <div class="header">
    <div :class="[{'header-fixed-true': isFxid}, 'header-fixed']">
      <div class="cover">
        <ul class="sign-user">
          <li><span @click="signUser">注册</span></li>
          <li><span @click="signUser">登录</span></li>
        </ul>
        <div class="logo" @click="goIndex" :style="{backgroundImage: 'url(' + logo + ')'}"></div>
      </div>
      <div class="nav" ref="nav">
        <sr-nav-top @click="signUser" v-show="isFxid"/>
        <sr-nav/>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="300px">
      <div class="sign-user-con">
        <p>请扫码关注公众号</p>
        <p>进入耀莱微信官网进行操作</p>
        <sr-qr-code :text="qrCodeText"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SrNavTop from './nav-top'
  import SrNav from './nav'
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      SrNavTop,
      SrNav,
      SrQrCode
    },
    data () {
      return {
        logo: './static/img/logo.png',
        dialogVisible: false,
        qrCodeText: 'http://weixin.qq.com/r/eDjA2OLE_b_Graa7921q',
        isFxid: false,
        top: 0,
        scroll: 0,
        scrollFlag: true
      }
    },
    methods: {
      goIndex () {
        this.$router.push('/index')
      },
      signUser () {
        this.dialogVisible = true
      },
      getTop () {
        this.top = this.$refs.nav.offsetTop
      },
      toScroll () {
        if (this.scrollFlag) {
          this.scrollFlag = !this.scrollFlag
          setTimeout(() => {
            this.scroll = document.body.scrollTop || document.documentElement.scrollTop
            if (this.scroll >= this.top) {
              this.isFxid = true
            } else {
              this.isFxid = false
            }
            this.scrollFlag = !this.scrollFlag
          }, 60)
        }
      }
    },
    mounted () {
      this.getTop()
      window.addEventListener('scroll', this.toScroll)
    }
  }
</script>

<style lang="less" scoped>
  .header {
    height: 130px;
    background-color: white;
    .header-fixed {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 3;
      transition: all .3s;
    }
    .header-fixed-true {
      transform: translate3d(0,-80px,0);
    }
    .cover {
      height: 80px;
      background-color: #1a1a1a;
      .logo {
        width: 230px;
        height: 80px;
        margin: 0 auto;
        text-indent: -12345px;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
      .sign-user {
        float: right;
        overflow: hidden;
        padding-right: 30px;
        list-style: none;
        li {
          line-height: 80px;
          float: left;
          margin-left: 12px;
          span {
            color: white;
            cursor: pointer;
            &:hover {
              color: #ccac66
            }
          }
        }
      }
    }
    .sign-user-con {
      text-align: center;
    }
    .nav {
      height: 50px;
      background-color: white;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue